export default "__VITE_ASSET__00541e30__"